import groq from 'groq';

import { ASSET, GIF, RICH_TEXT } from '../common';

export const MITOPURE_TRANSFORMATION = groq`
  title,
  link,
  mitopureTransformation -> {
    transformation[] {
      title,
      subtitle,
      description[] {
        ${RICH_TEXT}
      },
      image { ${ASSET} },
      video {
        ${GIF},
      }
    }
  }
`;

export const MITOPURE_TRANSFORMATION_BLOCK = groq`
  _type == 'mitopureTransformation' => {
    ${MITOPURE_TRANSFORMATION}
  }
`;
